import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import Navigation from '@/components/Navigation';
import { useAuth } from '@/context/auth';
import EmailDashboard from '@/components/email/dashboard/EmailDashboard';

const EmailCampaigns = () => {
  const { user } = useAuth();
  const restaurantId = user?.restaurants && user.restaurants.length > 0 ? user.restaurants[0].id : undefined;
  const organisationId = user?.organisationId;

  // Get the tab parameter from URL
  const [searchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab');
  const navigate = useNavigate();

  // Make sure the tab is properly set in URL if coming from a direct link without tab param
  useEffect(() => {
    if (!tabFromUrl) {
      // Only modify URL if there's no tab param yet
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.set('tab', 'campaigns'); // Default to campaigns
      navigate(`${window.location.pathname}?${newSearchParams.toString()}`, { replace: true });
    }
  }, [navigate, searchParams, tabFromUrl]);

  return (
    <Navigation>
      <EmailDashboard initialTab={tabFromUrl || 'campaigns'} />
    </Navigation>
  );
};

export default EmailCampaigns;
